// Mirror of /app/backend/app/data/locations.py — same content, exposed
// statically so the SPA can render location pages without an API roundtrip.
import locations from "../data/locations.json";

export const LOCATIONS = locations;

export const LOCATIONS_BY_SLUG = Object.fromEntries(
  locations.map((l) => [l.slug, l])
);

export function findLocationByPostcode(postcode) {
  if (!postcode || postcode.length < 4) return null;
  // 1) Exact match on the listed `postcode_sample`.
  const exact = LOCATIONS.find((l) => l.postcode_sample === postcode);
  if (exact) return exact;
  // 2) Prefix match — try longest prefix first so 4208 (Ormeau) wins over
  //    42 (Gold Coast) for the Ormeau postcode.
  const candidates = LOCATIONS
    .flatMap((l) => (l.postcode_prefixes || []).map((p) => ({ loc: l, p })))
    .sort((a, b) => b.p.length - a.p.length);
  for (const { loc, p } of candidates) {
    if (postcode.startsWith(p)) return loc;
  }
  return null;
}

export function nearestLocations(slug, n = 3) {
  const loc = LOCATIONS_BY_SLUG[slug];
  if (!loc) return [];
  return (loc.nearest_slugs || [])
    .slice(0, n)
    .map((s) => LOCATIONS_BY_SLUG[s])
    .filter(Boolean);
}
